import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { makeLeague as makeApiLeague } from '../../../api-calls/leagues'
import { deleteLeague as deleteApiLeague } from '../../../api-calls/leagues'
import { Dropdown, Menu, Icon, message, Popconfirm } from 'antd'
deleteApiLeague
@observer(["ViewStore", "UserStore", "CategoriesStore", "AuthStore", "LeagueStore"])
class ManageLeagues extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leagueTitle: '',
            leagueLogoUrl: '',
            categoryId: '',
            categoryName: '',
        };

        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleLogoUrlChange = this.handleLogoUrlChange.bind(this);
        this.onCategoryClick = this.onCategoryClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);

    }

    async componentWillMount() {
        const { CategoriesStore, LeagueStore } = this.props;

        CategoriesStore.queryCategories();
        LeagueStore.queryLeagues();
    }

    handleSubmit() {
        const { AuthStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;

        let title = this.state.leagueTitle;
        let logoUrl = this.state.leagueLogoUrl;
        let categoryId = this.state.categoryId;

        return makeApiLeague(
            authToken,
            title,
            logoUrl,
            categoryId,
        ).then(() => {
            message.success('League Added!');
        }).then(() => {
            this.setState({ leagueTitle: '', leagueLogoUrl: '', categoryId: '', categoryName: '' });
        });
    }

    handleTitleChange = (e) => {
        this.setState({ leagueTitle: e.target.value });
    }

    handleLogoUrlChange = (e) => {
        this.setState({ leagueLogoUrl: e.target.value });
    }

    renderCategoryMenu() {
        const { CategoriesStore } = this.props;
        let menuList = []

        CategoriesStore.categories.forEach(function (category) {
            menuList.push(<Menu.Item key={category._id}>
                <a target="_blank" rel="noopener noreferrer">{category.title}</a>
            </Menu.Item>);
        });

        return menuList;
    }

    onCategoryClick(key) {
        const { CategoriesStore } = this.props;
        let self = this;

        CategoriesStore.categories.forEach(function (category) {
            if (category._id == key.key) {
                self.setState({
                    categoryId: category._id,
                    categoryName: category.title
                });
            }
        });
    }

    renderLeagueDeleteList() {
        const { LeagueStore } = this.props;

        let leagueList = []
        let leagues = Array.from(LeagueStore.leagues.values());

        for (let league of leagues) {
            leagueList.push(
                <div className="admin-delete-table" key={league._id}>
                    <div className="admin-delete-table-column-title-logo">
                        {/* <img src={league.logoUrl} width="20" /> */}
                        <span>{league.title}</span>
                    </div>
                    <div>
                        <Popconfirm title={"Sure you want to delete " + league.title + "?"} onConfirm={() => { this.onClickDelete(league._id) }} okText="Yes" cancelText="No">
                            <button className="custom-btn-danger"><Icon type="delete" /></button>
                        </Popconfirm>

                    </div>
                </div>
            )
        }
        return leagueList;
    }


    onClickDelete(leagueId) {
        const { AuthStore, LeagueStore } = this.props;
        const authToken = AuthStore.userAuth.auth.accessToken;

        return deleteApiLeague(
            authToken,
            leagueId
        ).then(() => {
            message.success('League Deleted!')
        }).then(() => {
            LeagueStore.queryLeagues();
        });
    }

    render() {

        return (
            <div className="admin-wrap">
                <h2>Add a League</h2>
                <div className="admin-form">
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Title: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="League Title"
                            value={this.state.leagueTitle}
                            onChange={this.handleTitleChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Logo URL: </div>
                        <input
                            type="text"
                            className="custom-input"
                            style={{ width: '60%' }}
                            placeholder="League Logo URL"
                            value={this.state.leagueLogoUrl}
                            onChange={this.handleLogoUrlChange}
                        />
                    </div>
                    <div className="admin-form-field">
                        <div className="admin-form-field-title">Category: </div>
                        <Dropdown overlay={<Menu onClick={this.onCategoryClick}>{this.renderCategoryMenu()}</Menu>}>
                            {this.state.categoryId !== "" ?
                                <a className="admin-form-field-dropdown-link" href="#">{this.state.categoryName} <Icon type="down" /></a>
                                :
                                <a className="admin-form-field-dropdown-link" href="#">Select a Category <Icon type="down" /></a>
                            }
                        </Dropdown>
                    </div>
                </div>
                <div style={{ marginTop: '15px' }}>
                    <button onClick={this.handleSubmit} className="custom-btn-primary">Submit</button>
                </div>
                <br /><br /><br /><hr /><br /><br /><h1>Delete Leagues</h1><br />
                <div>
                    {this.renderLeagueDeleteList()}
                </div>
            </div>
        );
    }
}

export default ManageLeagues;


// WEBPACK FOOTER //
// ./src/components/appComponents/admin/ManageLeagues.js